// SY11 메뉴 저장·삭제 — 2.0 POST /api/v1/system/menus(새 행) · PUT /api/v1/system/menus/{id}(기존 행, menuCode 변경 불가) · DELETE /{id} (LOGISPRD-16595).
// 등록·삭제는 BE 가 같은 트랜잭션에서 권한별 MOMS_AUTH_INFO 행도 만들고 지운다. menuCode 중복이면 BE 400.
// 행별로 순서대로 반영하고, 실패하면 그 자리에서 멈춰 앞서 반영된 건수를 오류의 done 에 싣는다(공통코드와 같은 규약).
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import request from '@/utils/request'
import { inOrder } from '@/utils/inOrder'
import { MENUS_PATH, type MenuRow } from './useGetMenuList'

interface MenuUpdateBody {
  menuName: string
  menuType: string
  menuTree: string
  menuOrder: string
}
type MenuCreateBody = MenuUpdateBody & { menuCode: string }

export type MenuSaveRow = Omit<MenuRow, '_id'> & { _id?: number }

export const useSaveMenus = (): UseMutationResult<number, Error, MenuSaveRow[]> =>
  useMutation({
    mutationFn: (rows: MenuSaveRow[]) =>
      inOrder(rows, (row) => {
        // 검증은 trim 기준이라 보낼 때도 trim 한다 — 붙여넣은 'SY11 ' 이 공백 붙은 메뉴코드로 생기지 않게
        const body: MenuUpdateBody = { menuName: row.MENU_NM.trim(), menuType: row.MENU_TYP, menuTree: row.MENU_TREE, menuOrder: row.MENU_ORD }
        return row._id == null
          ? request.post<ApiResponseV2<unknown>, MenuCreateBody>(MENUS_PATH, { menuCode: row.MENU_CD.trim(), ...body })
          : request.put<ApiResponseV2<unknown>, MenuUpdateBody>(`${MENUS_PATH}/${row._id}`, body)
      }),
  })

export const useDeleteMenus = (): UseMutationResult<number, Error, number[]> =>
  useMutation({
    mutationFn: (ids: number[]) => inOrder(ids, (id) => request.delete<ApiResponseV2<unknown>>(MENUS_PATH, id)),
  })
